export function getPapersQueryString(recordId) {
  return `accelerator_experiments.record.$ref:${recordId}`;
}
